/**
 * Parallax Background Lazy Loading
 * Optimizes performance by loading background images only when they enter the viewport
 */

class ParallaxLazyLoader {
  constructor() {
    this.parallaxSections = document.querySelectorAll('.parallax-section[data-bg-image]');
    this.observer = null;
    this.init();
  }

  init() {
    console.log(
      '🚀 ParallaxLazyLoader: Initializing with',
      this.parallaxSections.length,
      'sections'
    );

    if (!this.parallaxSections.length) {
      console.log('⚠️ ParallaxLazyLoader: No parallax sections found');
      return;
    }

    // Create intersection observer with 50px root margin for preloading
    this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
      rootMargin: '50px 0px',
      threshold: 0.1,
    });

    // Observe all parallax sections
    this.parallaxSections.forEach((section, index) => {
      console.log(`👁️ ParallaxLazyLoader: Observing section ${index + 1}`, section);
      this.observer.observe(section);
    });
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      console.log('📍 ParallaxLazyLoader: Section intersection', {
        isIntersecting: entry.isIntersecting,
        isLoaded: entry.target.classList.contains('lazy-loaded'),
        element: entry.target,
      });

      if (entry.isIntersecting && !entry.target.classList.contains('lazy-loaded')) {
        console.log('🔄 ParallaxLazyLoader: Starting to load background image');
        this.loadBackgroundImage(entry.target);
      }
    });
  }

  loadBackgroundImage(section) {
    const bgImageUrl = section.getAttribute('data-bg-image');

    console.log('🖼️ ParallaxLazyLoader: Loading background image:', bgImageUrl);

    if (!bgImageUrl) {
      console.warn('⚠️ ParallaxLazyLoader: No background image URL found');
      return;
    }

    // Add loading class
    section.classList.add('lazy-loading');
    console.log('⏳ ParallaxLazyLoader: Added lazy-loading class');

    // Preload the image
    const img = new Image();

    img.onload = () => {
      console.log('✅ ParallaxLazyLoader: Image loaded successfully:', bgImageUrl);

      // Apply background image
      section.style.backgroundImage = `url(${bgImageUrl})`;

      // Update classes
      section.classList.remove('lazy-loading');
      section.classList.add('lazy-loaded');
      console.log('🎉 ParallaxLazyLoader: Background image applied and classes updated');

      // Stop observing this section
      this.observer.unobserve(section);
    };

    img.onerror = () => {
      // Handle error case
      section.classList.remove('lazy-loading');
      section.classList.add('lazy-error');
      console.error('❌ ParallaxLazyLoader: Failed to load background image:', bgImageUrl);
    };

    // Start loading
    console.log('🚀 ParallaxLazyLoader: Starting image preload');
    img.src = bgImageUrl;
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ParallaxLazyLoader();
  });
} else {
  new ParallaxLazyLoader();
}
